import { ColumnsType } from 'antd/es/table';
import { formatDate, formatNumber } from '../../../../utils/helper';
import { TreasuryTransaction } from '../../../../interfaces/Treasury';

export const TreasuryTransactionsSchema: ColumnsType<TreasuryTransaction> = [
    {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
        render: (text) => <span>NGN {formatNumber(parseFloat(text))}</span>
    },
    {
        title: 'Narration',
        dataIndex: 'narration',
        key: 'narration',
        render: (text) => <div className='max-w-sm text-xs'>{text}</div>
    },
    {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        render: (text) => <div className='capitalize'>{text}</div>
    },
    {
        title: 'Balance after transaction',
        dataIndex: 'balance',
        key: 'balance',
        render: (text) => <span>NGN {formatNumber(parseFloat(text))}</span>
    },
    {
        title: 'Date',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (_, { createdAt }) => <span>{formatDate(createdAt)}</span>
    }
];

export const dateRangeOptions = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Last week', value: 'lastWeek' },
    { label: 'Last month', value: 'lastMonth' },
    { label: 'Last year', value: 'lastYear' },
    { label: 'Custom Date range', value: 'custom' }
];

export type DateRangeOption =
    | 'today'
    | 'yesterday'
    | 'lastWeek'
    | 'lastMonth'
    | 'lastYear'
    | 'custom';

export const getDateRange = (
    option: DateRangeOption
): { startDate: Date; endDate: Date } => {
    const now = new Date();
    let endDate = new Date(now);
    let startDate = new Date(now);

    switch (option) {
        case 'today':
            startDate.setHours(0, 0, 0, 0);
            endDate.setHours(23, 59, 59, 999);
            break;

        case 'yesterday':
            startDate.setDate(now.getDate() - 1);
            startDate.setHours(0, 0, 0, 0);
            endDate.setDate(now.getDate() - 1);
            endDate.setHours(23, 59, 59, 999);
            break;

        case 'lastWeek': {
            const dayOfWeek = now.getDay();
            const lastWeekEnd = new Date(now);
            lastWeekEnd.setDate(now.getDate() - dayOfWeek);
            lastWeekEnd.setHours(23, 59, 59, 999);

            const lastWeekStart = new Date(lastWeekEnd);
            lastWeekStart.setDate(lastWeekEnd.getDate() - 6);
            lastWeekStart.setHours(0, 0, 0, 0);

            startDate = lastWeekStart;
            endDate = lastWeekEnd;
            break;
        }
        case 'lastMonth': {
            const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0);
            lastMonthEnd.setHours(23, 59, 59, 999);

            const lastMonthStart = new Date(
                now.getFullYear(),
                now.getMonth() - 1,
                1
            );
            lastMonthStart.setHours(0, 0, 0, 0);

            startDate = lastMonthStart;
            endDate = lastMonthEnd;
            break;
        }
        case 'lastYear':
            startDate = new Date(now.getFullYear() - 1, 0, 1);
            endDate = new Date(now.getFullYear() - 1, 11, 31, 23, 59, 59, 999);
            break;

        case 'custom':
            break;
        default:
            throw new Error('Custom date range must be handled manually.');
    }

    return { startDate, endDate };
};
